/* ============================================================
   Bundle picker — celebration FX (self-contained add-on).
   Adds, on top of the existing picker:
     • a product image "flies" from the Quick View into its tray slot
     • a soft beep on each add
     • confetti + a "Bundle complete!" toast when the last item lands
   Hooks the picker only via the public #bp-qv-add-btn click +
   window.BP_CONFIG.getSelection() — it never touches the picker's
   own logic, so it degrades gracefully if either changes.
   The orange→green progress bar is already handled by bundle-picker.
   ============================================================ */
(function () {
  'use strict';
  if (!document.getElementById('bundle-picker')) return;

  var SIZE = (window.BP_CONFIG && window.BP_CONFIG.bundleSize) || 7;
  var confettiDone = false; /* full confetti only once per page load */

  function getCount() {
    try { return (window.BP_CONFIG.getSelection() || []).length; }
    catch (e) { return null; }
  }

  /* ── add sound: plays the uploaded pop.wav (window.BP_POP_SOUND);
        falls back to a synth blip only if the file can't load ── */
  var actx = null, popBuffer = null, popRaw = null, popFetched = false;
  function loadPop() {
    if (popFetched || !window.BP_POP_SOUND) return;
    popFetched = true;
    try {
      fetch(window.BP_POP_SOUND)
        .then(function (r) { return r.arrayBuffer(); })
        .then(function (buf) { popRaw = buf; decodePop(); })
        .catch(function () {});
    } catch (e) {}
  }
  function decodePop() {
    if (!actx || !popRaw || popBuffer) return;
    var raw = popRaw; popRaw = null;
    try { actx.decodeAudioData(raw, function (b) { popBuffer = b; }, function () {}); }
    catch (e) {}
  }
  function ensureAudio() {
    try {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;
      if (!actx) actx = new AC();
      if (actx.state === 'suspended') actx.resume();
      decodePop();
    } catch (e) {}
  }
  function beep() {
    if (!actx) return;
    if (popBuffer) {
      try {
        var s = actx.createBufferSource(); s.buffer = popBuffer;
        var pg = actx.createGain(); pg.gain.value = 0.85;
        s.connect(pg); pg.connect(actx.destination);
        s.start(0); return;
      } catch (e) {}
    }
    /* fallback synth blip */
    try {
      var t = actx.currentTime;
      var o = actx.createOscillator(), g = actx.createGain();
      o.type = 'triangle';
      o.frequency.setValueAtTime(720, t);
      o.frequency.exponentialRampToValueAtTime(1180, t + 0.09);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.2, t + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.16);
      o.connect(g); g.connect(actx.destination);
      o.start(t); o.stop(t + 0.18);
    } catch (e) {}
  }
  loadPop(); /* start fetching the sound right away */

  /* ── fly a clone of the product image to a target element ── */
  function flyImage(imgSrc, fromRect, toEl) {
    if (!imgSrc || !fromRect || !fromRect.width || !toEl) return;
    var to = toEl.getBoundingClientRect();
    if (!to.width) return;
    var size = Math.min(fromRect.width, 110) || 80;
    var startX = fromRect.left + fromRect.width / 2 - size / 2;
    var startY = fromRect.top + fromRect.height / 2 - size / 2;
    var endX = to.left + to.width / 2 - size / 2;
    var endY = to.top + to.height / 2 - size / 2;
    var el = document.createElement('div');
    el.setAttribute('aria-hidden', 'true');
    el.style.cssText =
      'position:fixed;z-index:99999;pointer-events:none;left:0;top:0;' +
      'width:' + size + 'px;height:' + size + 'px;border-radius:50%;' +
      'background:#fff center/cover no-repeat;' +
      'background-image:url("' + String(imgSrc).replace(/["\\]/g, '') + '");' +
      'box-shadow:0 12px 30px rgba(0,0,0,.28);border:2px solid #fff;' +
      'transform:translate(' + startX + 'px,' + startY + 'px) scale(1);opacity:1;' +
      'transition:transform .72s cubic-bezier(.55,-0.3,.3,1.1),opacity .72s ease;';
    document.body.appendChild(el);
    el.getBoundingClientRect(); /* reflow */
    requestAnimationFrame(function () {
      el.style.transform = 'translate(' + endX + 'px,' + endY + 'px) scale(0.18)';
      el.style.opacity = '0.25';
    });
    setTimeout(function () {
      el.remove();
      if (toEl.animate) {
        try { toEl.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }],
          { duration: 320, easing: 'cubic-bezier(.3,1.4,.5,1)' }
        ); } catch (e) {}
      }
    }, 740);
  }

  /* ── confetti burst (vanilla canvas, no library) ──
        Physics is TIME-based (per elapsed ms, not per frame): Low Power
        Mode throttles rAF to ~30fps, and per-frame stepping played the
        whole burst in slow motion there. Now a throttled frame rate just
        renders chunkier for the same ~2s. Touch devices get fewer
        particles at 1x DPR (4x fewer pixels per frame). ── */
  function confetti() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
    var c = document.createElement('canvas');
    c.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:99998;';
    document.body.appendChild(c);
    var ctx = c.getContext('2d');
    var DPR = touch ? 1 : Math.min(window.devicePixelRatio || 1, 2);
    var W = c.width = window.innerWidth * DPR;
    var H = c.height = window.innerHeight * DPR;
    var colors = ['#BC6444', '#C2A56B', '#4a7a4a', '#1a1714', '#e8a36b', '#efe9df'];
    var parts = [], N = touch ? 60 : 150;
    var ox = W * 0.5, oy = H * 0.6;
    for (var i = 0; i < N; i++) {
      var a = Math.random() * Math.PI * 2, sp = (4 + Math.random() * 9) * DPR;
      parts.push({
        x: ox, y: oy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 6 * DPR,
        g: (0.18 + Math.random() * 0.12) * DPR, w: (6 + Math.random() * 6) * DPR,
        h: (8 + Math.random() * 8) * DPR, rot: Math.random() * 6.28,
        vr: -0.2 + Math.random() * 0.4, col: colors[i % colors.length],
        life: 0, ttl: (95 + Math.random() * 45) * 0.7  /* 60fps-frame units (ttl/60 ≈ s); ×0.7 = ~1.1–1.6s burst (owner: full length lingered) */
      });
    }
    var lastT = null;
    function frame(now) {
      /* dt = elapsed time in 60fps-frame units; at 30fps dt≈2 so physics
         advances double per tick instead of halving the playback speed.
         Clamped at 3 so a paused/hidden tab can't teleport particles. */
      var dt = (lastT === null || !now) ? 1 : Math.min((now - lastT) / 16.667, 3);
      lastT = now || lastT;
      ctx.clearRect(0, 0, W, H);
      var alive = false;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        if (p.life > p.ttl) continue;
        alive = true; p.life += dt;
        p.vy += p.g * dt; p.vx *= Math.pow(0.99, dt);
        p.x += p.vx * dt; p.y += p.vy * dt; p.rot += p.vr * dt;
        ctx.save();
        ctx.globalAlpha = Math.max(0, 1 - p.life / p.ttl);
        ctx.translate(p.x, p.y); ctx.rotate(p.rot);
        ctx.fillStyle = p.col; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }
      if (alive) requestAnimationFrame(frame); else c.remove();
    }
    requestAnimationFrame(frame);
  }

  /* ── "Bundle complete!" toast — tappable, proxies a click to the tray's
        CHECKOUT button so the full checkout flow (pixel, cart replace,
        loading state) runs exactly as if the tray button was pressed ── */
  function congrats() {
    var prev = document.getElementById('bp-congrats');
    if (prev) prev.remove();
    var d = document.createElement('div');
    d.id = 'bp-congrats';
    d.setAttribute('role', 'button');
    d.setAttribute('tabindex', '0');
    d.style.cssText =
      'position:fixed;left:50%;top:22%;z-index:100000;' +
      'background:#1a1714;color:#fff;padding:14px 28px;border-radius:22px;' +
      'font-weight:700;font-size:16px;letter-spacing:.01em;text-align:center;' +
      'box-shadow:0 16px 50px rgba(0,0,0,.35);cursor:pointer;' +
      '-webkit-tap-highlight-color:transparent;' +
      'transform:translate(-50%,-50%) scale(.85);opacity:0;' +
      'transition:opacity .35s ease,transform .45s cubic-bezier(.2,1.4,.4,1);';
    d.innerHTML =
      '<div style="white-space:nowrap;">🎉 Bundle complete — all ' + SIZE + ' picked!</div>' +
      '<div style="white-space:nowrap;font-size:13px;font-weight:600;color:#8fe0af;margin-top:4px;">' +
      'Tap to check out →</div>';
    function dismiss() {
      d.style.opacity = '0';
      d.style.transform = 'translate(-50%,-50%) scale(.9)';
      setTimeout(function () { d.remove(); }, 420);
    }
    function go(e) {
      if (e) e.preventDefault();
      dismiss();
      var btn = document.getElementById('bp-checkout-btn');
      /* the user may have removed a piece while the toast was up */
      if (btn && !btn.disabled) btn.click();
      else if (btn) btn.scrollIntoView({ block: 'nearest' });
    }
    d.addEventListener('click', go);
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') go(e);
    });
    document.body.appendChild(d);
    requestAnimationFrame(function () {
      d.style.opacity = '1';
      d.style.transform = 'translate(-50%,-50%) scale(1)';
    });
    setTimeout(function () {
      if (d.isConnected) dismiss();
    }, 4200);
  }

  /* ── pulse the tray's CHECKOUT button (glow only — the theme's global CSS
        hijacks transform, so no scale). Runs after the celebration so the
        eye lands on the CTA. ── */
  function pulseCheckout() {
    var btn = document.getElementById('bp-checkout-btn');
    if (!btn || btn.disabled) return;
    if (!document.getElementById('bp-cta-pulse-style')) {
      var st = document.createElement('style');
      st.id = 'bp-cta-pulse-style';
      st.textContent =
        '@keyframes bp-cta-pulse{' +
        '0%{box-shadow:0 4px 16px rgba(184,112,62,.35),0 0 0 0 rgba(184,112,62,.55);}' +
        '70%{box-shadow:0 4px 16px rgba(184,112,62,.35),0 0 0 14px rgba(184,112,62,0);}' +
        '100%{box-shadow:0 4px 16px rgba(184,112,62,.35),0 0 0 0 rgba(184,112,62,0);}}' +
        '.bp-cta-pulse{animation:bp-cta-pulse 1.1s ease-out 3;}';
      document.head.appendChild(st);
    }
    btn.classList.remove('bp-cta-pulse');
    void btn.offsetWidth; /* restart the animation if it's already applied */
    btn.classList.add('bp-cta-pulse');
    var clear = function () { btn.classList.remove('bp-cta-pulse'); };
    btn.addEventListener('animationend', clear, { once: true });
    btn.addEventListener('click', clear, { once: true });
  }

  /* Find the source image (and its on-screen rect) for the add that was clicked.
     QV add  -> the Quick View image; card "Add"/qty+ -> that card's image. */
  function sourceFor(trigger) {
    if (trigger.id === 'bp-qv-add-btn') {
      var ov = document.getElementById('bp-qv-overlay');
      var qv = document.getElementById('bp-qv-img');
      if (qv && qv.src && ov && getComputedStyle(ov).display !== 'none') {
        return { src: qv.currentSrc || qv.src, rect: qv.getBoundingClientRect() };
      }
    }
    var card = trigger.closest('.bp-card-wrapper') || trigger.closest('.bp-card');
    if (card) {
      var img = card.querySelector('.bp-card-img--primary') ||
        card.querySelector('.bp-card-img') || card.querySelector('img');
      if (img && (img.currentSrc || img.src)) {
        return { src: img.currentSrc || img.src, rect: img.getBoundingClientRect() };
      }
      if (card.dataset && card.dataset.image) {
        var wrap = card.querySelector('.bp-card-image-wrap') || card;
        return { src: card.dataset.image, rect: wrap.getBoundingClientRect() };
      }
    }
    return { src: null, rect: trigger.getBoundingClientRect() };
  }

  /* Source image (+ on-screen rect) for the fly animation, from the add event detail:
     Quick View image if the QV is open, else the added card's image. */
  function sourceForAdd(detail) {
    var ov = document.getElementById('bp-qv-overlay');
    var qv = document.getElementById('bp-qv-img');
    if (qv && qv.src && ov && getComputedStyle(ov).display !== 'none') {
      return { src: qv.currentSrc || qv.src, rect: qv.getBoundingClientRect() };
    }
    var card = detail && detail.cardEl;
    if (card) {
      var img = card.querySelector('.bp-card-img--primary') ||
        card.querySelector('.bp-card-img') || card.querySelector('img');
      if (img && (img.currentSrc || img.src)) {
        return { src: img.currentSrc || img.src, rect: img.getBoundingClientRect() };
      }
      var wrap = card.querySelector('.bp-card-image-wrap') || card;
      return { src: (detail && detail.image) || (card.dataset && card.dataset.image), rect: wrap.getBoundingClientRect() };
    }
    return { src: (detail && detail.image) || null, rect: null };
  }

  /* Unlock audio on the add-click gesture (Web Audio needs a user gesture to start). */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest &&
      e.target.closest('#bp-qv-add-btn, .bp-card-add-btn, .bp-inline-add-btn, .bp-card-qty-plus');
    if (!trigger || trigger.disabled || trigger.classList.contains('bp-card-add-btn--sold-out')) return;
    ensureAudio();
  }, true);

  /* Celebrate every successful add. Fired from bundle-picker.js addToSelection so it
     works for ALL paths — including the single/no-variant add that lands only after an
     async product fetch (which the old click+100ms timing check kept missing). */
  document.addEventListener('bundle:added', function (e) {
    var detail = (e && e.detail) || {};
    var now = (typeof detail.count === 'number') ? detail.count : getCount();
    beep();
    var src = sourceForAdd(detail);
    var slots = document.querySelectorAll('#bp-slots .bp-slot');
    var target = slots[(now || 1) - 1] ||
      document.getElementById('bp-progress-bar') ||
      document.getElementById('bp-tray');
    if (src && src.src && src.rect) flyImage(src.src, src.rect, target);
    if (now && now >= SIZE) {
      setTimeout(function () {
        /* full confetti only the FIRST time this page-load completes the
           bundle; a swap (remove one, re-add) still gets toast + pulse
           but not a second confetti storm */
        if (!confettiDone) { confettiDone = true; confetti(); }
        congrats();
        pulseCheckout();
      }, 360);
    }
  });
})();
